import { Alert, H3, H4, Intent } from '@blueprintjs/core';
import { useCallback } from 'react';

interface SlowUploadAlertProps {
  isOpen: boolean;
  onClose: () => void;
}

const SlowUploadAlert = ({ isOpen, onClose }: SlowUploadAlertProps) => {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Alert isOpen={isOpen} intent={Intent.WARNING} onClose={handleClose}>
      <H3>Atenção!</H3>
      <H4>A velocidade de upload está muito baixa!</H4>
      <p>Considere usar uma conexão mais rápida para melhor desempenho.</p>
    </Alert>
  );
};

export default SlowUploadAlert;
